<mat-card class="trinta-card recent-files-card mb-25 bg-white border-none d-block">
  <div
    class="trinta-form ml-auto mr-auto text-center bg-white position-relative z-1 border-radius" style="font-size: 16px;"
  >
    <h3>Welcome to AI Price Estimator</h3>
    <p style="color: #818093; margin-bottom: 28px;">Here is a quick overview of what you can do.</p>

    <div class="feature-grid">

      <!-- Estimator -->
      <a class="feature-card" routerLink="/main/apps/estimator-dual-photo">
        <div class="feature-icon estimator-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
          </svg>
        </div>
        <div class="feature-body">
          <h4>Estimator</h4>
          <p>Upload one or two product photos and let the AI identify the item, brand, material, and suggest a price. You can review and adjust the result before saving it to a session.</p>
        </div>
      </a>

      <!-- AI Training -->
      <a class="feature-card" routerLink="/main/apps/train">
        <div class="feature-icon training-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="3"></circle>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14"></path>
          </svg>
        </div>
        <div class="feature-body">
          <h4>AI Training</h4>
          <p>Help improve the model by uploading photos that clearly show the product, brand label, and price tag. Confirm or correct the predicted details before submitting — your corrections are used to retrain the AI.</p>
        </div>
      </a>

      <!-- My Sessions -->
      <a class="feature-card" routerLink="/main/apps/sessions">
        <div class="feature-icon sessions-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
            <line x1="8" y1="21" x2="16" y2="21"></line>
            <line x1="12" y1="17" x2="12" y2="21"></line>
          </svg>
        </div>
        <div class="feature-body">
          <h4>My Sessions</h4>
          <p>Group products into named sessions. Activate a session and every product you estimate will automatically be saved to it. When ready, export the full session as a CSV file with all product details in a tabular format.</p>
        </div>
      </a>

      <!-- Uploaded Products -->
      <a class="feature-card" routerLink="/main/stats">
        <div class="feature-icon stats-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"></line>
            <line x1="12" y1="20" x2="12" y2="4"></line>
            <line x1="6" y1="20" x2="6" y2="14"></line>
          </svg>
        </div>
        <div class="feature-body">
          <h4>Uploaded Products</h4>
          <p>Browse every product that has been submitted through the Estimator. View full product details, download the original photo, or permanently delete a record.</p>
        </div>
      </a>

    </div>

    <div class="home-note">
      <strong>Important:</strong> The AI model may make incorrect predictions. Always review and correct the details before saving — your corrections directly improve future accuracy.
    </div>
    <p style="margin-top: 16px; font-size: 14px; color: #818093;">
      Questions or issues? Contact us at
      <a href="mailto:{{supportEmail}}" style="color: #3e91ea;">{{supportEmail}}</a>
    </p>
  </div>
</mat-card>


<!-- <div class="logout-area">
  <div class="d-table">
      <div class="d-table-cell">
          <div
              class="trinta-form ml-auto mr-auto text-center bg-white position-relative z-1 border-radius"
          >
              <h3>
                  Home
              </h3>
              <span>
              </span>
              <div class="logo">
                  <img src="assets/images/black-yellow.png" alt="logo">
                  <img src="assets/images/white-yellow.png" alt="logo">
              </div>
              <span>
                Application in development
              </span>
          </div>
      </div>
  </div>
</div> -->
